<template>
<div class="container">
<mt-loadmore :bottom-method="loadBottom" :auto-fill="false" :bottom-all-loaded="allLoaded" ref="loadmore" class="loadmore">

<template v-for="(v,i) in team" v-if="team&&team.length>0">
<div class="row team left" v-if="i%2==0" @click="topush('/thm/doctor/d/'+v.id)">
  <div class="col-4">
    <div class="bblue">
       <img :src="picurl+v.pic" :alt="v.name"/>
    </div>
  </div>
  <div class="col-6">
    <div class="row"><b>{{v.name}}</b> <span class="gray">({{v.zw}})</span></div>
    <div class="row gray zy">{{v.zy}}...</div>
  </div>
</div>

<div class="row team right" v-if="i%2==1" @click="topush('/thm/doctor/d/'+v.id)">
  <div class="col-6">
    <div class="row" style="text-align:right;"><span class="gray">({{v.zw}})</span> <b>{{v.name}}</b> </div>
    <div class="row gray zy" style="text-align:right;">{{v.zy}}...</div>
  </div>
   <div class="col-4">
    <div class="bblue">
       <img :src="picurl+v.pic" :alt="v.name"/>
    </div>
  </div>
</div>

</template>	

<div class="row center" style="padding:1rem;" v-show="!allLoaded">
   <mt-button size="small" @click="loadBottom">查看更多</mt-button>
</div>

</mt-loadmore>

</div>
</template>


<style scoped>
.loadmore{float: left;padding-top: 1rem;}
.team{padding:.5rem .3rem;height:12rem;border-bottom: 1px solid #eee;position: relative;}
.team .bblue{background:rgb(0,144,255);width:7rem;height:9.6rem;position: absolute;}
.left .bblue{left:.5rem;}
.right .bblue{right:.5rem;}
.team img{width:7rem;height:8rem;position: absolute;top:.8rem;}
.left img{left:.8rem;}
.right img{right:.8rem;}
.team .col-6{padding:.5rem .8rem;}
.team .zy{padding-top: .6rem;}	
</style>


<script>

export default {
	data:function(){
		return {
		  picurl:picurl,
          team:"",
          allLoaded:false,
		}
	},
	created:function(){
		this.init();
	},
	methods:{
		init:function(){
			this.getlist(0);
		},
		getlist:function(start){
			var _this=this;
			var data={
				len:start,
			}
			if(start==0&&fun.cache(fun.url())){
               this.team=fun.cache(fun.url());
               return;
			}

			fun.post(api+"team",data,function(d){
				console.log(d);
				_this.$refs.loadmore.onBottomLoaded();
				if(d.status==1){
					if(_this.team){
						_this.team=_this.team.concat(d.info);
					}else{
						_this.team=d.info;
					}
					fun.cache(fun.url(),_this.team);
					if(d.info.length<6){
						_this.allLoaded=true;
					}
				}else{
					_this.$toast(d.info);
					_this.allLoaded=true;
				}
			})
		},
		loadBottom:function(){
          var start=this.team.length;
          this.getlist(start);
		},
		topush:function(url){
		 // var scrollTop = window.pageYOffset|| document.documentElement.scrollTop || document.body.scrollTop;
		 // fun.cache(fun.url()+"_scrolltop",scrollTop);
         this.$router.push(url);
        }
	}
}	
</script>


// WEBPACK FOOTER //
// src/components/thm/team.vue